import { FETCH_ACUMATICA_FAILURE_LOGS_SUCCESS } from './acumaticaLogTypes';
import produce from 'immer';

const initialState = {
  acumaticaFailureLogs: []
};

export default produce((draft = initialState, action) => {
  switch (action.type) {
    case FETCH_ACUMATICA_FAILURE_LOGS_SUCCESS:
      draft.acumaticaFailureLogs = action.response;
      break;

    default:
      break;
  }

  return draft;
}, initialState);
